import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery, handleSessionExpiredError } from '../../utils/auth';
import { PaginatedRequestType } from '../../types/pagination';
import { GetOfferParams, GetOffersParams } from './types';
import { OfferDetail } from '../../types/jobOffer';

// Define a service using a base URL and expected endpoints
export const offersApi = createApi({
  reducerPath: 'offersApi',
  baseQuery: getBaseQuery(),
  endpoints: (builder) => ({
    // Get jobs
    getOffers: builder.query<
      PaginatedRequestType<OfferDetail>,
      GetOffersParams
    >({
      query: (params) => ({
        url: '/public-offers',
        params,
      }),
    }),
    getOffer: builder.query<OfferDetail, GetOfferParams>({
      query: ({ id, isLogged }) => {
        if (isLogged) {
          return { url: `/offers/${id}` };
        }
        return { url: `/public-offers/${id}` };
      },
      transformErrorResponse: (response) => handleSessionExpiredError(response),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetOffersQuery, useGetOfferQuery } = offersApi;
